export default __webpack_public_path__ + "static/media/DJ_RAFF.e248ff3d.gif";